import { BaixaLinha, ContaFinanceiraUiConfig } from './conta-financeira.model';

export function numero(valor: unknown): number {
  const n = Number(valor);
  return Number.isFinite(n) ? n : 0;
}

export function calcValorAcrescimo(juros: unknown, multa: unknown): number {
  return numero(juros) + numero(multa);
}

export function calcValorPago(
  situacao: string | undefined,
  config: ContaFinanceiraUiConfig,
  valorBaixa: unknown,
  total: unknown
): number {
  if (situacao === config.situacaoQuitada) {
    const baixa = numero(valorBaixa);
    return baixa > 0 ? baixa : numero(total);
  }
  return 0;
}

export function calcValorRestante(total: unknown, valorPago: number): number {
  return Math.max(0, numero(total) - valorPago);
}

export function labelStatusPagamento(
  situacao: string | undefined,
  situacaoDescricao: string | undefined,
  config: ContaFinanceiraUiConfig
): string {
  if (situacaoDescricao) {
    return situacaoDescricao.toUpperCase();
  }
  if (situacao === config.situacaoQuitada) {
    return config.modo === 'pagar' ? 'PAGO' : 'RECEBIDO';
  }
  return config.modo === 'pagar' ? 'A PAGAR' : 'A RECEBER';
}

export function montarBaixasLista(params: {
  situacao?: string;
  pagamento?: string;
  valorBaixa?: unknown;
  total?: unknown;
  dtPagamento?: string;
  dtRecebimento?: string;
  possuiAnexoBaixa?: boolean;
  config: ContaFinanceiraUiConfig;
}): BaixaLinha[] {
  if (params.situacao !== params.config.situacaoQuitada || !params.pagamento) {
    return [];
  }
  const valor = numero(params.valorBaixa) || numero(params.total);
  return [{
    formaPagamento: params.pagamento,
    valor,
    dataPagamento: params.dtPagamento || params.dtRecebimento || '',
    possuiComprovante: !!params.possuiAnexoBaixa,
  }];
}

export function labelFormaPagamento(codigo: string): string {
  const mapa: Record<string, string> = {
    DINHEIRO: 'Dinheiro',
    CARTAO: 'Cartão',
    PIX: 'PIX',
    PERMUTA: 'Permuta',
  };
  return mapa[codigo] || codigo;
}
